/**
 * @format
 * @flow
 */
export const GET_MY_TASKS = 'GET_MY_TASKS';
export const GET_OLD_TASKS = 'GET_OLD_TASKS';
export const RESET_MY_TASKS = 'RESET_MY_TASKS';
export const RESET_OLD_TASKS = 'RESET_OLD_TASKS';
export const GET_TASK_DETAIL = 'GET_TASK_DETAIL';
export const RESET_TASK_DETAIL = 'RESET_TASK_DETAIL';
export const DELETE_TASK = 'DELETE_TASK';
export const RESET_DELETE_TASK = 'RESET_DELETE_TASK';
export const TASK_CONTRACT_CONTENT = 'TASK_CONTRACT_CONTENT';
export const RESET_CONTRACT_CONTENT = 'RESET_CONTRACT_CONTENT';
export const SAVE_CATEGORY = 'SAVE_CATEGORY';
export const EDIT_TASK = 'EDIT_TASK';
export const EDIT_TASK_RESET = 'EDIT_TASK_RESET';
export const CATEGORY_SAVE = 'CATEGORY_SAVE';
export const LICENSES_SAVE = 'LICENSES_SAVE';
export const REGISTER_TASK = 'REGISTER_TASK';
export const RESET_REGISTER_TASK = 'RESET_REGISTER_TASK';
export const SAVE_PAYMENT_INFO = 'SAVE_PAYMENT_INFO';
export const RESET_PAYMENT_INFO = 'RESET_PAYMENT_INFO';
export const RESET_APPLY_TASK = 'RESET_APPLY_TASK';
export const APPLY_TASK = 'APPLY_TASK';
export const RESET_CANCEL_TASK_FROM_ENTERPRISE = 'RESET_CANCEL_TASK_FROM_ENTERPRISE';
export const CANCEL_TASK_FROM_ENTERPRISE = 'CANCEL_TASK_FROM_ENTERPRISE';
export const RESET_CANCEL_TASK_FROM_USER = 'RESET_CANCEL_TASK_FROM_USER';
export const CANCEL_TASK_FROM_USER = 'CANCEL_TASK_FROM_USER';
export const SEND_REVIEW = 'SEND_REVIEW';
export const RESET_SEND_REVIEW = 'RESET_SEND_REVIEW';
export const SET_PARTICIPANT = 'SET_PARTICIPANT';
export const SAVE_INVOICE_INFO = 'SAVE_INVOICE_INFO';
export const RESET_INVOICE_INFO = 'RESET_INVOICE_INFO';
export const SET_TASK_STATUS = 'SET_TASK_STATUS';
export const GET_TASK_STATUS = 'GET_TASK_STATUS';
